import React from "react";
import { saveEmblemData, saveInstructions, wizardStore } from "../../../stores/wizard"
import { Step } from "../../../types/wizard";

interface SpecialInstructionsTextareaProps {
  step: Step;
}

export default function SpecialInstructionsTextarea({ step }: SpecialInstructionsTextareaProps) {
  const handleSpecialInstructions = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const specialInstructions = event.target.value;
      saveEmblemData(step.id, { specialInstructions })
      saveInstructions(step?.id, specialInstructions);
  }

  return (
    <div className='w-full flex flex-col items-start gap-2 mb-1'>
      <h2 className="">
        <span className="font-bold uppercase mr-2">Special Instructions</span>
        <span>(Optional)</span>
      </h2>
      <textarea
        className='border w-full rounded h-auto p-1 outline-none'
        style={{ border: "1px solid #ccc" }}
        onChange={handleSpecialInstructions}
        placeholder={wizardStore.step?.specialInstructionsPlaceholder || 'Please provide additional, detailed instructions here to help with the production of your design.'}
        value={wizardStore.emblemData[step?.id]?.specialInstruction}
      />
    </div>
  )
}